import { render, staticRenderFns } from "./SampleDeleteDescendants.vue?vue&type=template&id=9a0577b2&scoped=true&"
import script from "./SampleDeleteDescendants.vue?vue&type=script&lang=js&"
export * from "./SampleDeleteDescendants.vue?vue&type=script&lang=js&"
import style0 from "./SampleDeleteDescendants.vue?vue&type=style&index=0&id=9a0577b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0577b2",
  null
  
)

export default component.exports